import { format } from 'date-fns'

export const convertStringTimeStampIntoStringDate = (inputTimeStamp) => {
  const date = new Date(inputTimeStamp * 1000)
  const formattedDate = format(date, 'd MMMM yyyy, H:mm a')
  return formattedDate
}